import React from 'react';

import Attachments from '../../../../../Forms/Common/Attachments';
import { QuestionTypeShowProps } from './QuestionShow';

export default function AttachmentsShow({
  form,
  errors,
  index,
  setError,
  setDisabledForm,
  disabled,
  scope,
}: QuestionTypeShowProps) {
  const { control } = form;

  return (
    <Attachments
      name={`${scope}answers_attributes.${index}.attachments`}
      control={control}
      errors={errors}
      setError={setError}
      disabled={disabled}
      setDisabledForm={setDisabledForm}
      noTitle
    />
  );
}
